import type { Tables } from "@msuite/utils/types";
import { cva, type VariantProps } from "class-variance-authority";
import type { GetFileAnnotations, SaveFileAnnotations } from "../lightbox/shared";
import type { UseRemoteFileUrl } from "../types";

export interface FileInspectorBaseProps<T extends { id: string }>
	extends VariantProps<typeof fileInspector> {
	itemFiles: ItemFiles<T>;
	renderFile: (file: Tables<"files">) => React.ReactNode;
	getAnnotations?: GetFileAnnotations;
	onSaveAnnotations?: SaveFileAnnotations;
	annotatedFileIds?: Set<string>;
	/** Rendered inside the file list modal's body, below the file grid (e.g. an upload dropzone). */
	bodyContent?: React.ReactNode;
	/** Rendered inside the file list modal's footer, left of the "Done" button (e.g. an upload trigger). */
	footerContent?: React.ReactNode;
}

export interface FileInspectorModalProps<T extends { id: string }>
	extends FileInspectorBaseProps<T> {
	variant?: "modal";
	useRemoteFileUrl?: UseRemoteFileUrl;
}

export interface FileInspectorInlineProps<T extends { id: string }>
	extends FileInspectorBaseProps<T>,
		RemoteFetchHookProps {
	variant: "inline";
}

export interface RemoteFetchHookProps {
	useRemoteFileUrl: UseRemoteFileUrl;
}

export type FileInspectorProps<T extends { id: string }> =
	| FileInspectorModalProps<T>
	| FileInspectorInlineProps<T>;

export type ItemFiles<T extends { id: string }> = Array<
	T & {
		file: Tables<"files">;
	}
>;

export const fileInspector = cva([], {
	variants: {
		size: {
			xs: ["text-xs"],
			sm: [],
		},
	},
	defaultVariants: {
		size: "sm",
	},
});
